import React from "react"

const InsertField = ({type, placeholder = "", value, onChange, maxLength, onKeyPress, pattern}) => {

    return (
        <input
            className='element-border insert-field'
            autoComplete = "one-time-code"
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            onKeyDown={onKeyPress}
            pattern={pattern}
        />
    )
}

export default InsertField